import gsap from "gsap";

export function runLoader() {
    const loader = document.querySelector(".loader");
    if (!loader) return Promise.resolve();

    if (!document.documentElement.classList.contains("show-loader")) {
        loader.remove();
        return Promise.resolve();
    }

    return new Promise<void>(resolve => {
        let didFinish = false;

        const finish = () => {
            if (didFinish) return;
            didFinish = true;

            gsap.to(loader, {
                autoAlpha: 0,
                duration: 0.7,
                ease: "power2.out",
                onComplete: () => {
                    sessionStorage.setItem("hasSeenLoader", "1");
                    document.documentElement.classList.remove("show-loader");
                    loader.remove();
                    resolve();
                },
            });
        };

        window.addEventListener("logo:loader-sequence-complete", finish, { once: true });

        window.setTimeout(finish, 5000);
    });
}
